var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-body',[_c('page-header',{attrs:{"title":_vm.$t('scope.text_296')}}),_c('invoice-application-manager-list',{attrs:{"id":_vm.listId,"getParams":_vm.getParams}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }